var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_c('div',{staticClass:"d-flex flex-column flex-grow-1 relative"},[_c('transition',{attrs:{"name":_vm.transition}},[_c('keep-alive',[_c(_vm.currentView.name,{tag:"component",attrs:{"changeView":_vm.changeView,"params":_vm.view.params}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }